import { useId } from 'react';
import { ClipboardList } from 'lucide-react';
import type { LeadFormAnswer } from '@/utils/leadFormAnswers';

export default function LeadFormAnswers({ answers }: { answers?: LeadFormAnswer[] }) {
  const headingId = useId();
  if (!answers?.length) return null;

  return (
    <section aria-labelledby={headingId} className="min-w-0 overflow-hidden rounded-2xl border border-sky-200 bg-sky-50/50">
      <div className="flex items-start gap-3 border-b border-sky-100 p-4 sm:p-5">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-sky-700 shadow-sm">
          <ClipboardList className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <h3 id={headingId} className="text-base font-semibold text-slate-900">Απαντήσεις φόρμας</h3>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">Όσα δήλωσε ο πελάτης, για να προετοιμάσετε την επικοινωνία σας.</p>
        </div>
      </div>
      <dl className="grid gap-3 p-4 sm:p-5">
        {answers.map(answer => (
          <div key={answer.key} className="min-w-0 rounded-xl border border-slate-100 bg-white p-4">
            <dt className="break-words text-sm leading-relaxed text-slate-600">{answer.question}</dt>
            <dd className="mt-2 space-y-1 text-base font-semibold leading-relaxed text-slate-900 [overflow-wrap:anywhere]">
              {answer.values.map(value => <p key={value}>{value}</p>)}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
